import { render } from "./WebsiteAddButton.vue?vue&type=template&id=38b40e75&scoped=true"
import script from "./WebsiteAddButton.vue?vue&type=script&lang=js"
export * from "./WebsiteAddButton.vue?vue&type=script&lang=js"

import "./WebsiteAddButton.vue?vue&type=style&index=0&id=38b40e75&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b40e75"]])

export default __exports__